import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import IShopDto from '@core/mappers/country/dtos/IShopDto';
import Shop from '@models/country/Shop';

export default class ShopMapper extends AbstractMapper<IShopDto, Shop> {
    createTargetObject(dto: IShopDto, key: number): Shop {
        const shop = {} as Shop;

        shop.id = dto.ShopId;
        shop.comTradeId = dto.MarketingSourceId;
        shop.name = dto.ShopName;
        shop.isActive = dto.Active;
        shop.address = dto.Address;
        shop.city = dto.City;
        shop.latitude = dto.Latitude;
        shop.longitude = dto.Longitude;
        shop.state = dto.State;
        shop.openingHour = dto.OpeningHour;
        shop.closingHour = dto.ClosingHour;

        return shop;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/country/ShopMapper.ts